<template>
  <div class="container">
    <vk-offcanvas
      flipped
      overlay
      :show.sync="showOffCanvas"
    >
      <div>
        <vk-offcanvas-close @click="showOffCanvas = false"></vk-offcanvas-close>
        <EditInvoice :invoiceId="invoiceData.id" />
      </div>
    </vk-offcanvas>

    <div class="invoice-container">
      <div class="row">
        <div class="col-md-10 col-md-offset-1">
          <div class="row">
            <div class="col-sm-8">
              <div class="logo">
                <img :src="require('../../../assets/img/logo.png')" />
              </div>
            </div>
            <div class="col-sm-4 text-right">
              <div class="invoice-status text-right">
                <!-- <span :class="invoiceData.payload.order.status == 0 ? 'unpaid' : 'paid'">{{invoiceData.payload.order.status == 0 ? "UNPAID" : "PAID"}}</span> -->
                <span class="payment-status paid" v-if="ispayed">PAID</span>
                <div v-else class="unpaid-div">
                  <span class="payment-status unpaid">UNPAID</span>
                  <!-- should be update invoice -->
                  <can I="am" a="finance">
                    <b-button @click="showOffCanvas = true" variant="primary">Update</b-button>
                  </can>
                </div>
              </div>
              <can I="am" a="customer">
                <Rave
                  style="display: none"
                  :is-production="true"
                  text="Pay Now"
                  style-class="btn btn-primary"
                  id="paymentbtn"
                  :email="paymentData.email"
                  :amount="paymentAmount"
                  :reference="genRandomNumber"
                  :rave-key="raveKey"
                  :callback="callback"
                  :metadata="[
                    {
                      metaname: 'requestInfo',
                      metavalue: JSON.stringify(invoiceData)
                    }
                  ]"
                  paymentOptions="card,barter,account,ussd"
                  :payment_plan="parseInt(0)"
                  :close="close"
                  currency="NGN"
                  country="NG"
                  :customerFirstname="paymentData.firstname"
                  :customerLastname="paymentData.lastname"
                  :customerPhone="paymentData.phonenumber"
                ></Rave>
                <el-button
                  v-if="!ispayed"
                  type="btn btn-primary"
                  @click="triggerPayment"
                  >Pay Now</el-button
                >
              </can>
            </div>
          </div>

          <div class="row">
            <div class="col-md-8">
              <h3>
                Invoice No:
                {{ invoiceData.invoiceNo ? invoiceData.invoiceNo : "--" }}
              </h3>
            </div>

            <div class="col-md-4"></div>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-3 col-sm-6">
              <h5>Invoiced To:</h5>
              <address>
                {{
                  invoiceData.payload.user.firstName &&
                  invoiceData.payload.user.lastName
                    ? `${invoiceData.payload.user.firstName} ${invoiceData.payload.user.lastName}`
                    : "--"
                }}
                <br />
                {{
                  invoiceData.payload.user.phoneNumber
                    ? invoiceData.payload.user.phoneNumber
                    : invoiceData.user.phoneNumber || ""
                }}
                <br />
                {{
                  invoiceData.payload.user.email
                    ? invoiceData.payload.user.email
                    : "--"
                }}
                <!-- <br />Nigeria -->
              </address>
            </div>
            <div class="col-md-3 col-sm-6">
              <h5>Pay To:</h5>
              <address>
                22A, Adeleke Adedoyin Street,
                <br />Off Kofo Abayomi, Street, V.I. Lagos
                <br />
                <br />Tel: +234 802 288 8840, <br />+234 802 288 8841
              </address>
            </div>
            <div class="col-md-3 col-sm-6">
              <h5>Invoice Date:</h5>
              <p>
                {{
                  invoiceData.createdAt
                    ? new Date(invoiceData.createdAt).toDateString()
                    : "--"
                }}
              </p>
            </div>
          </div>

          <!-- cost breakdown table... -->
          <div class="table-responsive" style="text-align: left">
            <table class="table">
              <thead>
                <tr>
                  <td>Cost Breakdown</td>
                  <td class="text-right">Amount</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{
                      invoiceData.payload.comment
                        ? invoiceData.payload.comment
                        : invoiceData.payload["title"] || "No Comment"
                    }}
                  </td>
                  <td class="text-right">
                    {{ "₦"
                    }}{{
                      numberWithCommas(
                        invoiceData.payload.amount
                          ? invoiceData.payload.amount
                          : "0.0"
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td>{{ "VAT" }}</td>
                  <td class="text-right">
                    {{ "₦"
                    }}{{
                      numberWithCommas(
                        invoiceData.payload.invoiceVatAmount
                          ? invoiceData.payload.invoiceVatAmount
                          : "0.0"
                      )
                    }}
                  </td>
                </tr>
                <!-- <tr class="active">
                  <td>Sub Total</td>
                  <td
                    class="text-right"
                  >{{invoiceData.payload.invoiceTotalAmount ? invoiceData.payload.invoiceTotalAmount : invoiceData.payload.amount|| 0.0}}</td>
                </tr>-->

                <tr>
                  <td>
                    <h4>Total</h4>
                  </td>
                  <td class="text-right">
                    <h4>
                      {{ "₦"
                      }}{{
                        numberWithCommas(
                          invoiceData.payload.invoiceTotalAmount
                            ? parseFloat(
                                invoiceData.payload.invoiceTotalAmount
                              ).toFixed(2)
                            : invoiceData.payload.amount || "0.0"
                        )
                      }}
                    </h4>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <p class="text-center hidden-print">
      <router-link class="btn btn-link" to="/invoices"
        >&laquo; Back to Invoices</router-link
      >
      <a href="javascript:window.print()" class="btn btn-link">
        <i class="fa fa-print"></i> Print
      </a>
      <!-- <a href="downloadLink" class="btn btn-link" download> -->
      <!-- <a class="btn btn-link" @click="convertToPdf"> -->
      <!-- <i class="fa fa-arrow-down"></i> Download -->
      <!-- </a> -->
    </p>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { Card } from "element-ui";
import Rave from "vue-ravepayment";
import Fingerprint2 from "fingerprintjs2";
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import EditInvoice from "../kitchen/EditInvoice";
export default {
  name: "",
  components: {
    "el-card": Card,
    Rave,
    EditInvoice,
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
  },
  data() {
    return {
      //invoiceId : this.$route,
      downloadLink: window.location.href,
      ispayed: false,
      transDone: false,
      transComplete: false,
      showOffCanvas: false,
      raveKey: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
      // raveKey: "FLWPUBK_TEST-89e9c4e181bd9559a5d47e738cb3363a-X",
      invoiceData: {
        payload: {
          user: {
            email: ""
          }
        }
      },
      priceData: [],
      paymentAmount: 0.0,
      paymentData: {
        expirymonth: "00",
        expiryyear: "00",
        email: "",
        name: null,
        firstname: "John",
        lastname: "Doe",
        phonenumber: null,
        deviceFingerprint: "00000",
        //   country: "NG",
        //   currency: "NGN",
        device_fingerprint: {
          components: null,
          result: null
        }
      },
      payment: [
        {
          label: "Description",
          key: "description",
          field: "description",
          sortable: "true"
        },
        {
          label: "Amount",
          key: "price",
          field: "price",
          sortable: "true"
        }
      ],
      notifications: {
        showSuccessMsg: {
          type: "success",
          title: "Success",
          message: "Success Msg!"
        },
        showInfoMsg: {
          type: "info",
          title: "Information",
          message: "Info. Msg!"
        },
        showWarnMsg: {
          type: "warning",
          title: "Warning",
          message: "Warning Msg!"
        },
        showErrorMsg: {
          type: "error",
          title: "Error",
          message: "Error Msg!"
        }
      }
    };
  },
  methods: {
    getInvoiceData(id) {
      const httpUtils = this.$httpUtils;
      let filter;
      filter = {
        order: "id DESC",

        limit: 1,
        include: ["user"]
      };
      let url = `/invoices/${id}?filter=${JSON.stringify(filter)}`;
      httpUtils.instance
        .get(url)
        .then(response => {
          this.invoiceData = {
            ...response.data,
            type: "subscription"
          };
          this.paymentAmount =
            this.invoiceData.payload.invoiceTotalAmount ||
            this.invoiceData.payload.amount ||
            0.0;
          let { ispayed } = this.invoiceData;
          console.log({ ispayed, invoiceData: this.invoiceData });
          this.ispayed = ispayed;

          console.log("invoice_data", this.invoiceData);
        })
        .catch(error => {
          this.errors = "Error occured at our end!";
          this.invoiceData = {};
        });
    },
    numberWithCommas(val) {
      if (val != "" && val != null && typeof val != "undefined") {
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "";
      }
    },
    callback: function(response) {
      let trRef = response.data;
      trRef.data = trRef.tx == undefined ? trRef.data : trRef.tx;
      if (trRef.data.status === "successful") {
        this.transDone = true;
        this.notifications.showSuccessMsg = {
          ...this.notifications.showSuccessMsg,
          message: "Transaction Successful"
        };
        this.transComplete = this.concludeTransaction(
          trRef.data.txRef,
          this.$route.params.single
        );
      } else
        this.notifications.showErrorMsg = {
          ...this.notifications.showErrorMsg,
          message: "Transaction fails"
        };
      this.close();
    },
    close: function() {
      console.log("Payment closed");
      window.location.reload();
    },
    concludeTransaction(txRef, requestId) {
      var data = true;
      var str = JSON.stringify({
        txref: txRef,
        requestId: requestId
      });
      const tempReg = JSON.parse(str);
      const HTTP = this.$httpUtils.instance;
      const url = "/payments/initial/request";
      return HTTP.post(url, tempReg)
        .then(response => {
          this.myResponse = response.data.data[0];
          data = true;
          return true;
        })
        .catch(error => {
          console.log(error);
          var errorMsg = error.response.data.message;
          this.showErrorMsg({
            message: errorMsg
          });
          return false;
        });
      return data;
    },
    updatePaymentData() {
      this.paymentData = {
        ...this.paymentData,
        firstname: this.getUserSession.firstName,
        lastname: this.getUserSession.lastName,
        email: this.getUserSession.email,
        phonenumber: this.getUserSession.phoneNumber,
        name: `${this.getUserSession.firstName} ${this.getUserSession.lastName}`
      };
    },
    triggerPayment() {
      document.getElementById(`paymentbtn`).click();
    },
    convertToPdf() {
      // var doc = new jsPDF();
      // doc.text(20, 20, 'Hello world!');
      // doc.text(20, 30, 'This is client-side Javascript to generate a PDF.');
      // // Add new page
      // doc.addPage();
      // doc.text(20, 20, 'Visit CodexWorld.com');
      // // Save the PDF
      // doc.save('document.pdf');
    }
  },
  computed: {
    ...mapGetters(["getUserSession"]),
    genRandomNumber() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      text += Math.round(new Date().getTime() / 1000);
      return text;
    }
  },
  mounted() {
    this.getInvoiceData(this.$route.params.single);
    const container = this;
    let fp = Fingerprint2();
    this.updatePaymentData();
    fp.get(function(result, components) {
      container.paymentData.deviceFingerprint = result; // a hash, representing your device fingerprint
      container.paymentData.device_fingerprint = {
        result,
        components
      }; // an array of FP components
    });
  }
};
</script>

<style lang="scss" scoped>
.invoice-container {
  background-color: #fff;
  border-top: 15px #eee solid;
  border-bottom: 15px #eee solid;
  margin: 60px 0 15px;
  padding: 60px 0;
}
.invoice-container .invoice-status {
  text-transform: uppercase;
  font-size: 24px;
  font-weight: 600;
  margin: 20px 0 0;
}
.paid {
  color: #779500;
  border: 3px #779500 solid;
  padding: 5px 15px;
}
.unpaid {
  color: red;
  border: 3px red solid;
  padding: 5px 15px;
}
.table-responsive {
  min-height: 0.01%;
  overflow-x: auto;
}
td {
  text-align: left;
  color: #111;
}
.text-right {
  text-align: right !important;
}
.payment-status {
  display: inline-block;
  margin-bottom: 10px;
}
.unpaid-div {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  button {
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/invoices/single.vue